module.exports = __webpack_public_path__ + "img/logo-bioritmo.04bf54b9.png";